import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../src/context/AuthContext';
import AdminNav from '../../Components/Admin/AdminNav';
import PolicySearchSection from '../../Components/Admin/PolicySearchSection';
import AgentSearchSection from '../../Components/Admin/AgentSearchSection';
import RegisteredSearchSection from '../../Components/Admin/RegisteredSearchSection';
import AdminMaterialsSection from '../../Components/Admin/Materials/AdminMaterialsSection';
import LoginAttemptsSection from '../../Components/Admin/LoginAttemptsSection';
import ManageAdminSection from '../../Components/Admin/ManageAdminSection';
import RegistrationEmailSection from '../../Components/Admin/RegistrationEmailSection';
import EmptyHeader from '../../Components/Shared/EmptyHeader';



const AdminPage = ({ portalSettings }) => {
    const [activeSection, setActiveSection] = useState('registered-search-container');
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const psm = portalSettings || {};

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;

    //Set Site Title
    document.title = `${companyName} - Admin`;

    // Redirect if user role is >= 3
    useEffect(() => {
        if (!loading) { // only check after context finishes loading
            if (!user || user.role >= 3) {
                navigate('/home');
            }
            if (user.role == 2 && psm.hasPolicyPortal == false && psm.hasAgentPortal == false) {
                navigate('/home');
            }
        }
    }, [user, loading, navigate]);

    //Change the home page if policy or agent portal is allowed
    useEffect(() => {
        const defaultSection = getDefaultSection(portalSettings);
        setActiveSection(defaultSection);
    }, [portalSettings]);

    //get the specific allowed home screen
    const getDefaultSection = (portalSettings) => {
        if (psm?.hasPolicyPortal) {
            return 'policy-search-container';
        }

        if (psm?.hasAgentPortal) {
            return 'agent-search-container';
        }

        return 'registered-search-container';
    };


    const handleNavClick = (section) => {
        setActiveSection(section);
        setTimeout(() => {
            const sectionElement = document.getElementById(section);
            if (sectionElement) {
                sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    };

    if (loading) return <div className="text-center mt-5">Checking permissions...</div>;

    return (
        <div className="PolicyDetailsPage">
            <EmptyHeader />
            <AdminNav
                selectedSection={activeSection}
                onNavClick={handleNavClick}
            />

            {activeSection === 'policy-search-container' && <PolicySearchSection />}
            {activeSection === 'agent-search-container' && <AgentSearchSection />}
            {activeSection === 'registered-search-container' && <RegisteredSearchSection />}
            {activeSection === 'admin-materials-container' && <AdminMaterialsSection />}
            {activeSection === 'login-attempts-container' && <LoginAttemptsSection />}
            {activeSection === 'manage-admin-container' && <ManageAdminSection />}
            {activeSection === 'email-send-container' && <RegistrationEmailSection portalSettings={portalSettings} />}
        </div>
    );
};

export default AdminPage;
